<template>
    <div class="UserSearch">
        <Row :gutter="4">
            <!-- 选择公司 -->
            <div v-if="company==1">
              <Col span="4">
                  <Select v-model="companyId" filterable :placeholder="$t('permission_configuration_management.user.pleaseSelectCompany')" :transfer="true" @on-change="searchCompany">
                      <Option value=" " selected>{{$t('permission_configuration_management.user.all')}}</Option>
                      <Option :value="item.id" v-for="item in companyList" :key="item.id">{{item.name}}</Option>
                  </Select>
              </Col>
            </div>
            <Col span="4">
                <Input search v-model="userSearchKey" :placeholder="$t('permission_configuration_management.user.checkByUserName')" @on-search="searchUser()" />
            </Col>
            <Col span="4">
                <add-users></add-users>
            </Col>
        </Row>
    </div>
</template>
<script>
    import {setCookie,getCookie} from '../../../../utils/cookieUtil.js'
    import AddUsers from '../user/AddUsers'
    import TableUsers from '../user/TableUsers'
    var tableUsers = TableUsers;
    export default {
        name: 'UserSearch',
        components: {
            AddUsers
        },
    data () {
        return {
            company: getCookie(global.companyId),
            companyId: '',
            companyList: [],
            userSearchKey:'',
            userNames:''
        }
    },
    mounted: function(){
        if (this.company == 1) {
            this.getCompanyDropDownBox();
        }
    },
    methods: {
        // 获取公司下拉框
        getCompanyDropDownBox: function(){
           this.$api.company.getCompanyDropDownBox("userName",getCookie(global.cookieName))
             .then(res => {
                 this.companyList = res.data;
             });
         },
        // 按公司搜索
        searchCompany: function(){
            // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
            eventBus.$emit('companyId', this.companyId);
            tableUsers.methods.showAll();
        },
        searchUser: function(){
            eventBus.$emit('userNames', this.userSearchKey);
            tableUsers.methods.showAll();
        }
    }
}
</script>
<style scoped>
    .UserSearch
    {
        padding: 4px 0px 15px 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/user/UserSearch.vue